import { Textarea } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useFormContext } from '../../../../../../../../hooks'
import { AccountFromTemplateFormSchema } from '../../types'

export const AccountDescriptionFormItem = (): ReactElement => {
  const { t } = useTranslation()
  const { FormItem } = useFormContext<AccountFromTemplateFormSchema>()

  return (
    <FormItem
      label={t('description_optional')}
      name="description"
      render={({ field }) => (
        <Textarea {...field} placeholder={t('coa.account_from_base_form.description.placeholder')} size="sm" />
      )}
    />
  )
}
